import { render, staticRenderFns } from "./detial.vue?vue&type=template&id=665a192b&scoped=true"
import script from "./detial.vue?vue&type=script&lang=js"
export * from "./detial.vue?vue&type=script&lang=js"
import style0 from "./detial.vue?vue&type=style&index=0&id=665a192b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a192b",
  null
  
)

export default component.exports